if (!window.vf) {
    window.vf = {};
}

const NONCE_RETRY_LIMIT = 1;

const devLog = (...args) => {
    if (window.location.hostname.includes('localhost')) {
        console.log('[DEV ONLY]', ...args);
    }
}

const createUrl = (path, params) => {
    const url = new URL(wpApiSettings.root + 'visa-franchise/v1/' + path);

    if (params) {
        Object
            .keys(params)
            .forEach(key => url.searchParams.append(key, params[key]))
    }

    return url;
}

const nonceStorage = {
    key: (action) => 'vf-nonce-' + action,
    get: (targetAction) => {
        devLog('getting nonce from session storage...');

        const rawNonce = sessionStorage.getItem(
            nonceStorage.key(targetAction)
        );

        if (!rawNonce) {
            devLog('no nonce found in session storage');
            return null;
        }

        const {action, nonce} = JSON.parse(rawNonce);

        // Weird scenario, but just in case
        if (action !== targetAction) {
            devLog('nonce found in session storage, but action does not match');
            return null;
        }

        devLog('nonce found in session storage: ' + nonce);

        return nonce;
    },
    set: (action, data) => {
        devLog('setting nonce in session storage: ' + data.nonce);

        sessionStorage.setItem(
            nonceStorage.key(action),
            JSON.stringify(data)
        );
    },
    clear: (action) => {
        action = action || 'wp_rest';

        devLog('clearing nonce in session storage');

        sessionStorage.removeItem(
            nonceStorage.key(action)
        );
    }
}

const getOrFetchNonce = (action) => {
    action = action || 'wp_rest';

    const nonce = nonceStorage.get(action);

    if (nonce) {
        return Promise.resolve(nonce);
    }

    devLog('Fetching new nonce for action ' + action + '...');

    return fetch('/nonce-provider?action=' + action, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            action
        })
    })
        .then((response) => response.json())
        .then((data) => {
            devLog('Nonce fetched for action ' + action + ': ' + data.nonce);
            nonceStorage.set(action, data);
            return data.nonce;
        })
        .catch((error) => {
            devLog('Error requesting the nonce token: ' + error);
            return window.wpApiSettings.nonce;
        });
};

const get = async (path, data = {}, options = {}, retries = 0) => {
    const nonce = await getOrFetchNonce();

    return $
        .ajax({
            type: "GET",
            headers: {
                'X-WP-Nonce': nonce
            },
            processData: false,
            contentType: false,
            cache: false,
            data,
            url: createUrl(path, {...data, '_wpnonce': nonce}),
            ...options
        })
        .catch((error) => {
            devLog(error);

            // If we got a 403, we retry the request, updating the nonce
            if (error.status === 403 && retries < NONCE_RETRY_LIMIT) {
                devLog('Retrying request with new nonce...');
                nonceStorage.clear();
                return get(path, data, options, retries + 1);
            }

            return {};
        });
}


window.vf.services = {
    getOrFetchNonce,
    get,
    clearNonce: () => nonceStorage.clear()
};